import type { RouteRecordRaw } from 'vue-router';
import {
  DASHBOARD_ROUTE_NAMES as DASHBOARD_INTERNAL_ROUTE_NAMES,
  DASHBOARD_ROUTE_PATHS as DASHBOARD_INTERNAL_ROUTE_PATHS,
} from '@/modules/dashboard/constants/dashboardRoutes.constant';
import { DASHBOARD_ROUTE_NAMES, DASHBOARD_ROUTE_PATHS } from '@/shared/common/constants/dashboardRoutes.constant';

function MainLayout() {
  return import('@/shared/layouts/pages/MainLayout/index.vue');
}
function EmptyLayout() {
  return import('@/shared/layouts/pages/EmptyLayout/index.vue');
}
function HomePage() {
  return import('../pages/Home/index.vue');
}
function WalletsPage() {
  return import('../pages/Wallets/index.vue');
}
function CreateCompensationAccountPage() {
  return import('../pages/CreateCompensationAccount/index.vue');
}

export const dashboardRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: {
      name: DASHBOARD_ROUTE_NAMES.HOME,
    },
    component: MainLayout,
    children: [
      {
        path: DASHBOARD_ROUTE_PATHS[DASHBOARD_ROUTE_NAMES.HOME],
        name: DASHBOARD_ROUTE_NAMES.HOME,
        component: HomePage,
        meta: {
          title: 'Bienvenido',
          subTitle: 'last-connection',
        },
      },
      {
        path: DASHBOARD_INTERNAL_ROUTE_PATHS[DASHBOARD_INTERNAL_ROUTE_NAMES.WALLETS],
        name: DASHBOARD_INTERNAL_ROUTE_NAMES.WALLETS,
        meta: {
          title: 'Mis Monedas',
          accessRol: {
            section: 'WALLET',
            actions: ['VIEW'],
          },
        },
        component: WalletsPage,
      },
    ],
  },
  {
    path: DASHBOARD_ROUTE_PATHS[DASHBOARD_ROUTE_NAMES.CREATE_COMPENSATION_ACCOUNT],
    component: EmptyLayout,
    children: [
      {
        path: '',
        name: DASHBOARD_ROUTE_NAMES.CREATE_COMPENSATION_ACCOUNT,
        component: CreateCompensationAccountPage,
      },
    ],
  },
  {
    path: DASHBOARD_INTERNAL_ROUTE_PATHS[DASHBOARD_INTERNAL_ROUTE_NAMES.CREATE_WALLET],
    name: DASHBOARD_INTERNAL_ROUTE_NAMES.CREATE_WALLET,
    redirect: { name: DASHBOARD_ROUTE_NAMES.HOME },
  },
];
